<script lang="ts">
    import {getInjector} from 'core/svelte-context/context';
    import LocaleDataService from './locale.data-service';

    export let locale: string;

    const injector = getInjector();
    const localeDataService = injector.getByToken<LocaleDataService>(LocaleDataService.serviceName);
</script>

<button class="locale-change-item-btn" on:click={() => localeDataService.setLocale(locale)}>
    <slot/>
</button>

<style lang="less">
    .locale-change-item-btn {
        display: inline-block;
        cursor: pointer;
        border: none;
        outline: none;
        background: none;
        padding: 0;
        margin: 0;
    }
</style>